import { render, staticRenderFns } from "./AdminActivityGroupTableRow.vue?vue&type=template&id=c85b6a62&"
import script from "./AdminActivityGroupTableRow.vue?vue&type=script&lang=js&"
export * from "./AdminActivityGroupTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports